import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from './../../../../themes/default';

const styles = theme => ({
  root: { display: 'block', maxWidth: '100%' },
  bold: { fontWeight: 600 }
});

const Group = ({ label, value, classes }) => {

  return (
    <div>
      <Typography component="p" variant="subtitle2" className={ classes.bold }>{ label }</Typography>
      <Typography component="p" variant="body2">{ value }</Typography>
    </div>
  )

}

Group.propTypes = {
  label: PropTypes.string.isRequired,
  // value: PropTypes.oneOfType([
  //   PropTypes.string.isRequire,
  //   PropTypes.number.isRequire
  // ])
};

export default withStyles(styles)(Group);
